import { connect } from 'react-redux';
import formClientActions from '../../stores/FormClient/actions';

import FormClient from '../components/formClient';

const mapStateToProps = (state) => {
  const { formClient } = state;

  const {
    isInitializing,
    isError,
    isSubmitting,
    isSubmitted,
    submitErrorMessage,
    teamName,
    userName,
    companyName,
    JSONSchema,
    UISchema,
    headerImage,
    confirmationText,
    buttonLabel,
    buttonColor
  } = formClient;

  return {
    isInitializing,
    isError,
    isSubmitting,
    isSubmitted,
    submitErrorMessage,
    teamName,
    userName,
    companyName,
    JSONSchema,
    UISchema,
    headerImage,
    confirmationText,
    buttonLabel,
    buttonColor
  };
};

const mapDispatchToProps = dispatch => ({
  onFormClientInitialize:
    (formId, token) => dispatch(formClientActions.formClientInit(formId, token)),
  onFormClientSubmit:
    (formData, token) => dispatch(formClientActions.formClientSubmit(formData, token))
});

export default connect(mapStateToProps, mapDispatchToProps)(FormClient);
